import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("cutit_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("cutit_token");
      localStorage.removeItem("cutit_user");
      if (window.location.pathname !== "/connexion" && window.location.pathname !== "/" && !window.location.pathname.startsWith("/book/")) {
        window.location.href = "/connexion";
      }
    }
    return Promise.reject(error);
  }
);

export default API;
